import React from "react";
import { createConsumer } from "@rails/actioncable";
import PropTypes from "prop-types";
import moment from "moment";
import lodash from "lodash";
import axios from "axios";

import Information from "./Information";
import Employees from "./Employees";
import Buttons from "./Buttons";
import CheckIn from "./CheckIn";
import SignatureSection from "./SignatureSection";
import { redirectTo } from "../../../utils/helpers";
import { Provider } from "mobx-react";
import MessagingStorage from "../../../storages/MessagingStorage";

class InService extends React.Component {
  state = {
    saving: false,
    edit: false,
    inService: this.props.inService,
    signature: this.props.signature,
    checkInAt: this.props.checkInAt,
    completed: this.props.inService.completed,
    employees: this.props.inService.employees,
    employeesSkills: this.props.inService.in_service_user_skills,
    employeesSkillsEdit: [],
    subscription: null
  };

  componentWillMount() {
    this.saveWithDelay = lodash.debounce(this.saveCallbackDelay, 400);
    this.subscribeToInServiceChannel();
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  subscribeToInServiceChannel = () => {
    this.connection = createConsumer('/cable')
    const subscription = this.connection.subscriptions.create({
      channel: 'InServiceChannel',
      in_service_id: this.props.inService.id
    }, {
      connected: () => {},
      disconnected: () => {},
      received: (inServiceData) => {
        if(Application.currentUser.id === inServiceData.updateByUser.id) return;

        let newEmployeesSkillsEdit = this.state.employeesSkillsEdit
        lodash.map(inServiceData.in_service.in_service_user_skills, (inServiceUserSkill) => {
          const employeeSkill = lodash.find(this.state.employeesSkills, { id: inServiceUserSkill.id })
          const employeeSkillEditIndex = lodash.findIndex(newEmployeesSkillsEdit, { id: inServiceUserSkill.id})
          if (!newEmployeesSkillsEdit[employeeSkillEditIndex]) {
            newEmployeesSkillsEdit.push(inServiceUserSkill);
            return;
          }

          if (employeeSkill.status === newEmployeesSkillsEdit[employeeSkillEditIndex].status) {
            newEmployeesSkillsEdit[employeeSkillEditIndex].status = inServiceUserSkill.status
          }

          if (employeeSkill.notes === newEmployeesSkillsEdit[employeeSkillEditIndex].notes) {
            newEmployeesSkillsEdit[employeeSkillEditIndex].notes = inServiceUserSkill.notes
          } else if (employeeSkill.notes !== inServiceUserSkill.notes) {
            newEmployeesSkillsEdit[employeeSkillEditIndex].notes = `${inServiceUserSkill.notes}\n${newEmployeesSkillsEdit[employeeSkillEditIndex].notes}`
          }
        })

        this.setState({
          inService: inServiceData.in_service,
          completed: inServiceData.in_service.completed,
          employees: inServiceData.in_service.employees,
          employeesSkills: inServiceData.in_service.in_service_user_skills,
          employeesSkillsEdit: newEmployeesSkillsEdit
        })

        toastr.info(`In-Service updated by ${inServiceData.updateByUser.name}`)
      }
    })

    this.setState({subscription})
  }

  unsubscribe = () => {
    if (!this.state.subscription) return;

    this.state.subscription.unsubscribe()
  }

  handleEmployeesAdded = employees =>
    this.setState({ employees: [...this.state.employees, ...employees] });

  toggleEdit = () => {
    this.setState({
      edit: !this.state.edit,
      employeesSkillsEdit: this.state.employeesSkills.map(item => ({...item}))
    });
  };

  toggleComplete = () => {
    this.setState({ completed: !this.state.completed }, () => {
      const { inService: { id } } = this.props;
      const { completed } = this.state;
      axios.put(`/in_services/${id}/status`, { completed });
    });
  };

  handleUpdateSkill = (employeeId, skillId, { status, notes }, isMobile = false) => {
    // const { employeesSkillsEdit } = this.state;
    const records = isMobile ? this.state.employeesSkills : this.state.employeesSkillsEdit;
    const idx = lodash.findIndex(records, {
      user_id: employeeId, in_service_category_skill_id: skillId
    });

    if (idx === -1) {
      records.push({
        status,
        notes,
        user_id: employeeId,
        in_service_category_skill_id: skillId
      });
    } else {
      records[idx].status = status;
      records[idx].notes = notes || ""
    }

    if (isMobile) {
      this.setState({ employeesSkills: records }, this.saveWithDelay);
    } else {
      this.setState({ employeesSkillsEdit: records });
    }
  };

  handleToggleAll = (employeeId, isMobile = false) => {
    const { skills } = this.props;
    const records = isMobile ? this.state.employeesSkills : this.state.employeesSkillsEdit;
    const status = (lodash.filter(records, {
      user_id: employeeId,
      status: true
    }).length === skills.length);

    if (!confirm(`Are you sure you want to mark all skills as ${status ? "un" : ""}complete?`)) {
      return;
    }

    skills.forEach(({ id }) => {
      const idx = lodash.findIndex(records, {
        user_id: employeeId, in_service_category_skill_id: id
      });

      if (idx === -1) {
        records.push({
          status: !status,
          notes: "",
          user_id: employeeId,
          in_service_category_skill_id: id
        });
      } else {
        records[idx].status = !status;
      }
    });

    if (isMobile) {
      this.setState({ employeesSkills: records }, this.saveWithDelay);
    } else {
      this.setState({ employeesSkillsEdit: records });
    }
  };

  handleSignature = signature => this.setState({ signature });

  destroyEmployee = id => {
    if (!confirm("Are you sure you want to delete this employee?")) {
      return;
    }

    const tmpEmployees = [ ...this.state.employees ];
    const tmpEmployeesSkills = [ ...this.state.employeesSkills ];

    const employees = lodash.filter(tmpEmployees, e => e.id !== id);
    const employeesSkills = lodash.filter(tmpEmployeesSkills, es => es.user_id !== id);
    this.setState({ employees, employeesSkills });

    axios.delete(`${window.location.pathname}/employees/${id}`)
      .then(() => {
        toastr.error("Deleted.");
      })
      .catch(() => {
        toastr.error("An error occured, please try again.");
        this.setState({ employees: tmpEmployees, employeesSkills: tmpEmployeesSkills });
      });
  };

  saveCallbackDelay = () => {
    const { employeesSkills } = this.state;
    this.save(null, employeesSkills);
  };

  save = (e, records = this.state.employeesSkillsEdit) => {
    const { saving } = this.state;
    if(saving) { return; }
    this.setState({ saving: true });

    const employeesSkills = this.buildDataSkills(records).flat();
    const data = {in_service_user_skills_attributes: employeesSkills};

    axios.put(`${window.location.pathname}/employees`, data)
      .then(({ data }) => {
        this.setState({
          saving: false,
          edit: false,
          employeesSkills: data,
          employeesSkillsEdit: []
        });
      })
      .catch(() => {
        this.setState({ saving: false });
      })
    ;
  };

  duplicate = () => {
    if (!confirm("Are you sure you want to duplicate this in-service?")) {
      return;
    }

    const { inService } = this.props;
    const { id } = inService;

    redirectTo(`/in_services/${id}/duplicate`);
  };

  destroy = () => {
    if (!confirm("Are you sure you want to delete this in-service?")) {
      return;
    }

    const { inService: { id } } = this.props;
    axios.delete(`/in_services/${id}`)
      .then(() => {
        window.location.href = "/in_services";
      })
      .catch(() => {
        toastr.error("Unknown error, please repeat again.");
      });
  };

  showPdf = () => {
    const { inService: { id } } = this.props;

    redirectTo(`/in_services/${id}.pdf`);
  };

  buildDataSkills = records => {
    const { employees } = this.state;
    const { skills } = this.props;

    return lodash.map(employees, employee => (
      lodash.map(skills, skill => {
        const employeeSkill = lodash.find(records, {
          user_id: employee.id, in_service_category_skill_id: skill.id
        });

        return {
          id: employeeSkill && employeeSkill.id,
          notes: employeeSkill ? employeeSkill.notes : "",
          user_id: employee.id,
          in_service_category_skill_id: skill.id,
          status: (employeeSkill ? employeeSkill.status : false)
        };
      })
    ));
  };

  checkedIn = checkInAt => this.setState({ checkInAt });

  render() {
    const {
      inService,
      employees,
      employeesSkills,
      employeesSkillsEdit,
      signature,
      checkInAt,
      completed,
      edit,
      saving
    } = this.state;
    const {
      isAdmin,
      defUsers,
      configured,
      generalFiles,
      instructorsFiles,
      skills,
      currentUser
    } = this.props;

    const messagingStorage = new MessagingStorage(
      Application.currentUser.locations
    );
    const storage = { messagingStorage };

    return (
      <Provider {...storage}>
        <div>
          <h1>In-Service</h1>
          {isAdmin && skills.length > 0 ? (
            <div className="row mb-15 hidden-xs">
              <div className="col-lg-12">
                <div className="pull-right">
                  <Buttons
                    isEdit={edit}
                    saving={saving}
                    completed={completed}
                    allowCompleted={employeesSkills.length > 0}
                    allowToEdit={employees.length > 0}
                    onToggleComplete={this.toggleComplete}
                    onToggle={this.toggleEdit}
                    onSave={this.save}
                    onDuplicate={this.duplicate}
                    onDelete={this.destroy}
                    onPdf={this.showPdf}
                    inService={inService}
                  />
                </div>
              </div>
            </div>
          ) : null}

          <div className="row in-service">
            <div className="col-lg-4">
              <Information
                completed={completed}
                inService={inService}
                generalFiles={generalFiles}
                instructorsFiles={instructorsFiles}
              />

              {!isAdmin && checkInAt ? (
                <SignatureSection
                  signature={signature}
                  onDone={this.handleSignature}
                />
              ) : null}
            </div>

            {skills.length === 0 ? (
              <div className="grey-text text-center">
                This In-service dosen't have any skills.
              </div>
            ) : (
              <div className="col-lg-8">
                {isAdmin || checkInAt ? (
                  <Employees
                    isAdmin={isAdmin}
                    isEdit={edit}
                    defUsers={defUsers}
                    employees={employees}
                    employeesSkills={edit ? employeesSkillsEdit : employeesSkills}
                    skills={skills}
                    inServiceUsers={inService.in_service_users}
                    onEmployeesAdded={this.handleEmployeesAdded}
                    onUpdateSkill={this.handleUpdateSkill}
                    onCheckAll={this.handleToggleAll}
                    onDelete={this.destroyEmployee}
                    currentUser={currentUser}
                  />
                ) : <CheckIn onDone={this.checkedIn}/>}
              </div>
            )}
          </div>
        </div>
      </Provider>
    );
  }
}

InService.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  checkInAt: PropTypes.string,
  inService: PropTypes.object.isRequired,
  skills: PropTypes.arrayOf(PropTypes.any).isRequired,
  defUsers: PropTypes.array.isRequired,
  configured: PropTypes.bool.isRequired,
  generalFiles: PropTypes.array.isRequired,
  instructorsFiles: PropTypes.array.isRequired,
  signature: PropTypes.objectOf(PropTypes.any),
  currentUser: PropTypes.object.isRequired
};

InService.defaultProps = {
  checkInAt: null,
  signature: null
};

export default InService;
